import {
  bathroomCondition,
  exteriorCondition,
  kitchenCondition,
  livingRoomCondition,
} from 'src/helpers/flows/pages/roomCondition';
import { FlowPageSet } from 'src/lib/flow/FlowPage';

/**
 * This pageset is not gated by an experiment; it is accessible
 * by going to /kitchen-condition?seller_flow=untreated_room_condition
 * The seller_flow query param is necessary to enter the flow.
 */
export const untreatedRoomConditionPageSet: FlowPageSet = [
  kitchenCondition,
  bathroomCondition,
  livingRoomCondition,
  exteriorCondition,
];
